import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getHeadlines = async (controller) => {
  try {
    const url = config.apiserver + "/menu/headline/";
    console.log(url);
    let res = await Axios.get(url, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getNewMenu = async (newDatas, controller) => {
  try {
    let url = config.apiserver + "/menu/getnewmenu/";
    if (controller.authenticated) {
      url = config.apiserver + "/menu/getnewmenuuser/";
    }
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getMenu = async (newData, controller) => {
  try {
    let url = config.apiserver + "/menu/getmenu";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getCapsuleWithID = async (newData, controller) => {
  try {
    let url = config.apiserver + "/menu/getcapsulewithid";

    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
